import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const BASE = `${process.env.REACT_APP_API_URL}/api/inventario/notificaciones`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

// GET /api/inventario/notificaciones[?solo_no_leidas=true]
export const getNotifInventario = async (soloNoLeidas = false) => {
    try {
        const url = soloNoLeidas ? `${BASE}?solo_no_leidas=true` : BASE;
        const r = await axios.get(url, auth());
        return r.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// GET /api/inventario/notificaciones/contador → { no_leidas }
export const getContadorInventario = async () => {
    try {
        const r = await axios.get(`${BASE}/contador`, auth());
        return r.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// PUT /api/inventario/notificaciones/:id/leida
export const marcarLeidaInventario = async (id) => {
    try {
        const r = await axios.put(`${BASE}/${id}/leida`, {}, auth());
        return r.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// PUT /api/inventario/notificaciones/leidas (todas)
export const marcarTodasInventario = async () => {
    try {
        const r = await axios.put(`${BASE}/leidas`, {}, auth());
        return r.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};
